/**
 * Состояние подтверждения otp
 */
export enum OtpConfirmationStatus {
    /**
     * Успешная операция (генерация/проверка OTP)
     */
    OK = 'OK',

    /**
     * Неверный OTP.
     */
    WRONG = 'WRONG',

    /**
     * Срок действия OTP истек.
     */
    EXPIRED = 'EXPIRED',

    /**
     * Ожидание доступности очередного OTP.
     */
    WAITING = 'WAITING',

    /**
     * Попытки исчерпаны (генерация/проверка OTP).
     */
    EXHAUSTED = 'EXHAUSTED',
}
